<template>
    <div class="header-box">
        <div class="header">
            <img class="icon" src="/images/logo-kyuseiki.png" alt="JACA"/>
        </div>
    </div>
</template>

<script>
export default {
    name: "Header"
}
</script>

<style scoped>

</style>
